export const ALLOWED_TEXT_SYMBOLS = ['™', '©', '®', '℗', '℠'];
